var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReturnKey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Image",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 183,
    height: 108,
    viewBox: "0 0 183 108",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "_Image",
    "data-name": "\\uD83D\\uDDBC Image",
    width: 183,
    height: 108,
    rx: 10,
    fill: "#fff",
    stroke: "#e0e0e0",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_maskieren_1",
    "data-name": "Gruppe maskieren 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_9041429_key_fill_icon",
    "data-name": "9041429_key_fill_icon",
    d: "M19.5,43.5A19.5,19.5,0,1,1,37.117,15.644H77.99L86.347,24,77.99,32.357l-5.571-5.571-5.571,5.571-5.571-5.571-5.571,5.571-5.571-5.571-5.571,5.571H37.117A19.5,19.5,0,0,1,19.5,43.5ZM13.925,29.571A5.571,5.571,0,1,0,8.354,24,5.571,5.571,0,0,0,13.925,29.571Z",
    transform: "translate(48.326 30.001)",
    fill: "#bebebe"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturnKey);
export default __webpack_public_path__ + "static/media/return_key.056ceb58a2ac30397543ebaadfad3d1e.svg";
export { ForwardRef as ReactComponent };